import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import CloseIcon from '../svg/close-icon';
import LocationIcon from '../svg/location-icon';
import DownCaretIcon from '../svg/down-caret-icon';

import Floor1 from '../svg/Floor1';
import Floor2 from '../svg/Floor2';
import Floor3 from '../svg/Floor3';
import Floor4 from '../svg/Floor4';

const rooms = [
    ['threshold', 'dance-floor', 'pool', 'staircases'],
    ['cat-walk', 'group-sex-room', 'locker-room'],
    ['private-rooms'],
    ['photo-booth-temple']
];


const FloorMap = ({ room }) => {
    const [currentFloor, setCurrentFloor] = useState(() => {
        for (let i = 0; i < rooms.length; i++) if (rooms[i].includes(room)) return i + 1;
        return 1;
    });
    const [hoveredRoom, setHoveredRoom] = useState(null);

    useEffect(() => {
        document.getElementById('floor-selector').value = `${currentFloor}`;
    })

    const dropDowns = [
        <ul className='room-dropdown'>
            <Link to="/explore/threshold">
                <li className={
                        `room-dropdown-li 
                        ${room === 'threshold' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'threshold' ? ' room-dropdown-li-hover' : ''}`
                    } 
                    tabIndex='0'
                    data-path='threshold-path'>
                        1. The Threshold {room === 'threshold' && <LocationIcon />}
                </li>
            </Link>
            <Link to="/explore/dance-floor">
                <li className={
                        `room-dropdown-li 
                        ${room === 'dance-floor' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'dance-floor' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='dance-floor-path'>
                        2. The Dance Floor {room === 'dance-floor' && <LocationIcon />}
                </li>
            </Link>
            <Link to="/explore/pool">
                <li className={
                        `room-dropdown-li 
                        ${room === 'pool' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'pool' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='pool-path'>
                        3. The Pool {room === 'pool' && <LocationIcon />}
                </li>
            </Link>
            <Link to="/explore/staircases">
                <li className={
                        `room-dropdown-li 
                        ${room === 'staircases' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'staircases' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='staircases-path'>
                        4. The Staircases {room === 'staircases' && <LocationIcon />}
                </li>
            </Link>
        </ul>,
        <ul className='room-dropdown'>
            <Link to="/explore/cat-walk">
                <li className={
                        `room-dropdown-li 
                        ${room === 'cat-walk' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'cat-walk' ? ' room-dropdown-li-hover' : ''}`
                    } 
                    tabIndex='0'
                    data-path='cat-walk-path'>
                        5. The Cat Walk {room === 'cat-walk' && <LocationIcon />}
                </li>
            </Link>
            <Link to="/explore/group-sex-room">
                <li className={
                        `room-dropdown-li 
                        ${room === 'group-sex-room' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'group-sex-room' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='group-sex-room-path'>
                        6. The Group Sex Room {room === 'group-sex-room' && <LocationIcon />}
                </li>
            </Link>
            <Link to="/explore/locker-room">
                <li className={
                        `room-dropdown-li 
                        ${room === 'locker-room' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'locker-room' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='locker-room-path'>
                        7. The Locker Room {room === 'locker-room' && <LocationIcon />}
                </li>
            </Link>
        </ul>,
        <ul className='room-dropdown'>
            <Link to="/explore/private-rooms">
                <li className={
                        `room-dropdown-li 
                        ${room === 'private-rooms' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'private-rooms' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='private-rooms-path'>
                        8. The Private Rooms {room === 'private-rooms' && <LocationIcon />}
                </li>
            </Link>
        </ul>,
        <ul className='room-dropdown'>
            <Link to="/explore/photo-booth-temple">
                <li className={
                        `room-dropdown-li 
                        ${room === 'photo-booth-temple' ? ' room-dropdown-active' : ''}
                        ${hoveredRoom === 'photo-booth-temple' ? ' room-dropdown-li-hover' : ''}`
                    }
                    tabIndex='0'
                    data-path='photo-booth-temple-path'>
                    9. The Photo Booth/Temple {room === 'photo-booth-temple' && <LocationIcon />}
                </li>
            </Link>
        </ul>
    ];

    useEffect(() => {
        document.querySelectorAll('.room-dropdown-li').forEach(el => {
            const roomOverlay = document.getElementById(el.dataset.path);
            if (roomOverlay) {
                el.addEventListener('mouseenter', () => roomOverlay.setAttribute('fill', '#FFA1C3'));
                el.addEventListener('mouseleave', () => roomOverlay.setAttribute('fill', '#565656'));
                el.addEventListener('keypress', e => {
                    if (e.key === ' ' || e.key === 'Enter') {
                        el.click();
                    }
                });
            }
        });
    });

    const closeIconOnClick = () => {
        document.getElementById('floor-map').className += ' hidden'
        document.getElementById('floor-map-background-layer').className += ' hidden'
    }

    return (
        <>
        <div id='floor-map-background-layer' className='floor-map-background-layer hidden'></div>
        <div id='floor-map' className='floor-map-container hidden'>
            <h2 className='floor-map-title'>Palace Floor Plan</h2>
            <div className='floor-map-disclaimer'>Jump to any room from here. Access nine key locations inside the Pussy Palace. </div>
            <div className='floor-map-horizontal-flex-container'>
                <div className='floor-select'>
                    <div className='floor-select-dropdown'>
                        <select 
                            name='floor' 
                            id='floor-selector'
                            onChange={e => setCurrentFloor(Number(e.target.value))}
                            >
                                <option value='1'>1ST FLOOR</option>
                                <option value='2'>2ND FLOOR</option>
                                <option value='3'>3RD FLOOR</option>
                                <option value='4'>4TH FLOOR</option>
                        </select>
                    </div>

                    <a className='dd-button' href='/explore/entrance'>Entrance</a>
                    <button onClick={e => setCurrentFloor(Number(1))} className={currentFloor === 1 ? 'active' : ''}>1ST FLOOR</button>
                    {currentFloor === 1 && (
                    <ul className='room-dropdown'>
                        <Link to="/explore/threshold">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'threshold' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'threshold' ? ' room-dropdown-li-hover' : ''}`
                                } 
                                tabIndex='0'
                                data-path='threshold-path'>
                                    Threshold {room === 'threshold' && <LocationIcon />}
                            </li>
                        </Link>
                        <Link to="/explore/dance-floor">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'dance-floor' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'dance-floor' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='dance-floor-path'>
                                    Dance Floor {room === 'dance-floor' && <LocationIcon />}
                            </li>
                        </Link>
                        <Link to="/explore/pool">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'pool' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'pool' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='pool-path'>
                                    Pool {room === 'pool' && <LocationIcon />}
                            </li>
                        </Link>
                        <Link to="/explore/staircases">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'staircases' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'staircases' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='staircases-path'>
                                    Staircases {room === 'staircases' && <LocationIcon />}
                            </li>
                        </Link>
                    </ul>
                    )}
                    <button onClick={e => setCurrentFloor(Number(2))} className={currentFloor === 2 ? 'active' : ''}>2ND FLOOR</button>
                    {currentFloor === 2 && (
                    <ul className='room-dropdown'>
                        <Link to="/explore/cat-walk">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'cat-walk' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'cat-walk' ? ' room-dropdown-li-hover' : ''}`
                                } 
                                tabIndex='0'
                                data-path='cat-walk-path'>
                                    Cat Walk {room === 'cat-walk' && <LocationIcon />}
                            </li>
                        </Link>
                        <Link to="/explore/group-sex-room">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'group-sex-room' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'group-sex-room' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='group-sex-room-path'>
                                    Group Sex Room {room === 'group-sex-room' && <LocationIcon />}
                            </li>
                        </Link>
                        <Link to="/explore/locker-room">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'locker-room' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'locker-room' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='locker-room-path'>
                                    Locker Room {room === 'locker-room' && <LocationIcon />}
                            </li>
                        </Link>
                    </ul>
                    )}
                    <button onClick={e => setCurrentFloor(Number(3))} className={currentFloor === 3 ? 'active' : ''}>3RD FLOOR</button>
                    {currentFloor === 3 && (
                    <ul className='room-dropdown'>
                        <Link to="/explore/private-rooms">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'private-rooms' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'private-rooms' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='private-rooms-path'>
                                    Private Rooms {room === 'private-rooms' && <LocationIcon />}
                            </li>
                        </Link>
                    </ul>
                    )}
                    <button onClick={e => setCurrentFloor(Number(4))} className={currentFloor === 4 ? 'active' : ''}>4TH FLOOR</button>
                    {currentFloor === 4 && (
                    <ul className='room-dropdown'>
                        <Link to="/explore/photo-booth-temple">
                            <li className={
                                    `room-dropdown-li 
                                    ${room === 'photo-booth-temple' ? ' room-dropdown-active' : ''}
                                    ${hoveredRoom === 'photo-booth-temple' ? ' room-dropdown-li-hover' : ''}`
                                }
                                tabIndex='0'
                                data-path='photo-booth-temple-path'>
                                Photo Booth/Temple {room === 'photo-booth-temple' && <LocationIcon />}
                            </li>
                        </Link>
                    </ul>
                    )}
                </div>
                <div className='room-select-container'>
                    <div className='floor-image'>
                        {currentFloor === 1 && <Floor1 currentRoom={room} setHoveredRoom={setHoveredRoom}/>}
                        {currentFloor === 2 && <Floor2 currentRoom={room} setHoveredRoom={setHoveredRoom}/>}
                        {currentFloor === 3 && <Floor3 currentRoom={room} setHoveredRoom={setHoveredRoom}/>}
                        {currentFloor === 4 && <Floor4 currentRoom={room} setHoveredRoom={setHoveredRoom}/>}
                    </div>
                </div>
                
            </div>
            <div className='floor-map-close-button-wrapper' style={{textAlign: 'right'}}>
                <CloseIcon onClick={closeIconOnClick}/>
            </div>
        </div>
        </>
    );
}

export default FloorMap;